import { makeStyles } from "../Utilities/ThemeHelper";
export const useStyles = makeStyles(theme => ({
  closeButton: {
    marginLeft: "auto"
  },
  container: {
    position: "relative",
    zIndex: 5
  },
  filterButtonPadding: {
    paddingRight: 0
  },
  filterDivider: {
    margin: theme.spacing(0.5)
  },
  filterListItem: {
    "& .prmbl-listItem": {
      padding: theme.spacing(0, 2)
    },
    maxHeight: theme.spacing(50)
  },
  filterListItemWrapper: {
    overflow: "auto"
  },
  filterPopover: {
    maxHeight: "none"
  },
  filterSelectAll: {
    padding: theme.spacing(0, 2)
  },
  filterTitleWrapper: {
    display: "flex",
    alignItems: "center",
    padding: theme.spacing(1, 2, 0, 2)
  },
  filterTitle: {
    display: "flex",
    alignItems: "baseline"
  },
  focused: {
    "&&": {
      width: "100%"
    }
  },
  outerWrapper: {
    width: "100%",
    maxWidth: props => props.maxWidth
  },
  root: {
    transition: theme.transitions.create("width"),
    width: props => `${props.initialWidth}%`
  },
  resetButton: {
    marginLeft: theme.spacing(0.5),
    color: theme.palette.grey[600]
  },
  suggestionsContainer: {
    position: "absolute",
    left: 2,
    right: 2,
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    borderTop: 0,
    overflow: "hidden",
    top: props => props.margin === false ? "100%" : `calc(100% - ${theme.spacing(1)}px)`
  },
  suggestion: {
    cursor: "pointer",
    padding: theme.spacing(2),
    color: theme.palette.text.primary
  },
  suggestionHighlighted: {
    background: theme.palette.action.selected,
    color: theme.palette.text.primary
  },
  suggestionsList: {
    margin: 0,
    padding: 0,
    listStyle: "none"
  },
  searchFilterWrapper: {
    maxWidth: theme.spacing(28),
    paddingBottom: theme.spacing(1)
  },
  withSearch: {
    height: "100%"
  }
}));